import { render, staticRenderFns } from "./AboutMethodPrinciplesBlock.vue?vue&type=template&id=f234402e"
import script from "./AboutMethodPrinciplesBlock.vue?vue&type=script&lang=js"
export * from "./AboutMethodPrinciplesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports